import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AutenticateApiService } from "../../api/autenticate-api.service";
import { SlideCaptchaComponent } from '../slide-captcha/slide-captcha.component'
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit, AfterViewInit {

    @ViewChild('usuario', { static: false }) usuario: ElementRef;
    @ViewChild('password', { static: false }) password: ElementRef;    
    @ViewChild('secretkey',{static:false}) secretkey:ElementRef

  /*   @ViewChild(SlideCaptchaComponent , { static: false } ) recaptcha:SlideCaptchaComponent; */

    languaje="es"
    errores=""
    errorMessage:string
    isUserPassFieldsError = false
    isLoading = false
    hallowen:boolean
    navidad:boolean
    normal:boolean
    disabled=true
    captcha:string = ""

    constructor(
        private autenticateApi: AutenticateApiService,
        private router: Router,
        private translate:TranslateService  
    ) {
        this.translate.setDefaultLang(this.languaje)
     }

    ngOnInit() { 
       this.validarfechasespeciales();
    }
    validarfechasespeciales(){
        let month=(new Date()).getMonth();
        let monthfinaly=month+1;

        if(monthfinaly == 10){
            this.hallowen=false;
            this.normal=true;  
        }

        if(monthfinaly==12){
            this.navidad=false;
            this.normal=true;  
        }

        if(monthfinaly<10){
            this.normal=true; 
        }

        if(monthfinaly==11){
            this.normal=true; 
        }

    }
    ngAfterViewInit() { } 

    showPassword(){
    if(this.password.nativeElement.type =="password"){
            this.password.nativeElement.type = "text"
     }else {
            this.password.nativeElement.type = "password"
     }
    }

    onCaptchaResponse(event) {
        this.captcha = event.toString()
    }

    send(){
  
      
       if( this.usuario.nativeElement.value == "" && this.password.nativeElement.value =="" ){
      
           this.errorMessage =this.translate.instant('usuario y contraseña son requeridos')
           return 
       } 

       if(this.captcha ==""){
        this.errorMessage =this.translate.instant('completar el Recaptcha')
        return 
      }
    
       
        this.isLoading = true
        this.errores =""
        this.autenticateApi.login(this.usuario.nativeElement.value, this.password.nativeElement.value)
        .subscribe(autenticated => {
            this.router.navigate(['/app']);
       /*      this.recaptcha.resetCaptcha()    */                 
            this.isLoading = false
            this.errorMessage = undefined;

        }, (error:HttpErrorResponse ) => {
            
            if (error.status == 401) {
                this.errorMessage = error.error.message
                this.isLoading = false
               /*  this.recaptcha.resetCaptcha() */
                
            }

            if(error.status == 0){
                this.errorMessage = this.translate.instant('Connection error')
                this.isLoading = false
              /*   this.recaptcha.resetCaptcha() */

            }
        })
       
      
    }
    cambiarIdioma(field){
        this.translate.use(field)
    }
}